import React from 'react';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import { useSectors } from '@/hooks/useSectors';

const MAX = 3;

export const SectorPicker = ({ value = [], onChange }) => {
  const { t } = useTranslation();
  const { sectors, nameOf } = useSectors();
  const available = sectors.filter((s) => !value.includes(s.slug));

  const add = (slug) => { if (slug && value.length < MAX && !value.includes(slug)) onChange([...value, slug]); };
  const remove = (slug) => onChange(value.filter((s) => s !== slug));

  return (
    <div data-testid="sector-picker">
      <p className="text-sm text-gray-500 mb-3">{t('candidateProfile.sectorsHelp', { max: MAX })}</p>
      <div className="flex flex-wrap gap-2 mb-3" data-testid="sector-picker-selected">
        {value.map((slug) => (
          <span key={slug} className="bg-emerald-100 text-emerald-800 px-3 py-1 rounded-full text-sm flex items-center gap-1" data-testid={`sector-chip-${slug}`}>
            {nameOf(slug)}
            <button type="button" onClick={() => remove(slug)} className="hover:text-emerald-950" aria-label={t('candidateProfile.removeSector')} data-testid={`sector-remove-${slug}`}>
              <X className="h-3.5 w-3.5" />
            </button>
          </span>
        ))}
        {value.length === 0 && <span className="text-sm text-gray-400">{t('candidateProfile.noSectors')}</span>}
      </div>
      <select
        value=""
        onChange={(e) => add(e.target.value)}
        disabled={value.length >= MAX}
        className="w-full h-10 rounded-md border border-gray-300 bg-white px-3 text-sm disabled:opacity-50"
        data-testid="sector-picker-select"
      >
        <option value="">{value.length >= MAX ? t('candidateProfile.sectorsMax', { max: MAX }) : t('candidateProfile.addSector')}</option>
        {available.map((s) => <option key={s.slug} value={s.slug}>{nameOf(s)}</option>)}
      </select>
    </div>
  );
};
